import { useContext, useEffect, useState } from "react";
import { CustomTabs } from "../../../common/components/Tabs/CustomTabs";
import { OperationConstant } from "../../operations/core/_constant";
import StorageContainerList from "./StorageContainerList";
import StorageBagList from "./StorageBagList";
import StorageVehicleList from "./StorageVehicleList";

import StorageCraftList from "./StorageCraftList";
import { StorageContext } from "../StorageDetail";
import StorageOtherList from "./StorageOtherList";
import { Empty } from "antd";
import { useLocation } from "react-router";

export const StorageTabList = () => {
  const initialValue = useContext(StorageContext);
  const [tabItems, setTabItems] = useState<Array<any>>([]);
  const location = useLocation();
  // const [type, setType] = useState<string>("");

  const storageType = initialValue?.["@type"] ?? "";

  useEffect(() => {
    // setType(initialValue?.['@type']);
    if (initialValue?.loadPossessionStatus.length > 0) {
      setTabItems(
      initialValue?.loadPossessionStatus?.map(
        (item: any) => {
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: setComponents(item?.id),
          };
        }
      )
    );
    }
  }, [initialValue]);

  const setComponents = (id: string) => {
    switch (id) {
      case OperationConstant.CONTAINER_ID:
        return <StorageContainerList key={location.pathname} storageType={storageType}/>;

      case OperationConstant.BAG_ID:
        return<StorageBagList key={location.pathname} storageType={storageType} />;

      case OperationConstant.VEHICLE_ID:
        return <StorageVehicleList key={location.pathname} storageType={storageType} />;

      case OperationConstant.CRAFT_ID:
        return <StorageCraftList key={location.pathname} storageType={storageType} />;

      case OperationConstant.OTHER_ID:
        return <StorageOtherList key={location.pathname} storageType={storageType}/>;

      default:
        return <StorageContainerList key={location.pathname} storageType={storageType}/>;
    }
  };
  return (
    <>
      {
        tabItems.length > 0 ? (
          <CustomTabs items={tabItems} tabName="type" />
        )
        :
        (
          <div className="mt-5">
            <Empty description={"Aucune donnée"}/>
          </div>
        )
      }
    </>
  );
};
